<script>
    import V from 'voUtils/V.js'

    export default {
    	voVueComponent: 'feedback-carousel',
    	props: {
    		carouselId: String
    	},

    	mounted: function() {
    		$("#owl-" + this.carouselId).owlCarousel({
    			items: 1,
    			loop: true,
    			autoplay: true,
    			dots: true,
    			smartSpeed: 2000,
    			nav: false,
    			autoplayTimeout: 8000,
    			responsive: {

    				0: {
    					items: 1
    				},

    				768: {
    					items: 1
    				},
    				992: {
    					items: 1
    				}
    			}
    		});
    	}
    };
</script>